let executed = false;

let intervalId = setInterval(() => {
  if (document.readyState == "complete") {
    executed = true;
    clearInterval(intervalId);

    const originalPrice = document.querySelector(
      ".product-form__info-content .price"
    )?.lastChild.textContent;
    window.hulk_vd_table_data = [{ start: 1, value: originalPrice }];

    document
      .querySelectorAll(".hulkapps-table tbody tr")
      .forEach((tableRow) => {
        const intervalCell = tableRow.querySelector(":nth-child(1)");

        // try to match number+
        let numbers = intervalCell?.textContent.match(/\d+/g);
        if (!numbers) {
          console.warn("HULK VD custom script error", "interval not parsed");
          return;
        }
        const start = parseInt(numbers[0]);
        const value = tableRow.querySelector(
          ":nth-child(2) .money"
        )?.textContent;
        window.hulk_vd_table_data.push({ start, value });
      });
    const quantityInput = document.querySelector('input[name="quantity"]');

    function changePrice(quantity) {
      let price = null;
      const numberOfPriceLevels = window.hulk_vd_table_data.length;
      for (let i = 0; i < numberOfPriceLevels; i++) {
        const currentLevel = window.hulk_vd_table_data[i];
        if (quantity >= currentLevel.start) {
          price = currentLevel.value;
        } else {
          break;
        }
      }
      if (price == null) return;
      const priceTextNode = document.querySelector(
        ".product-form__info-content .price"
      )?.lastChild;
      priceTextNode.textContent = price;
    }

    quantityInput?.addEventListener("input", (event) => {
      changePrice(event.target.value);
    });
    document
      .querySelectorAll("button.quantity-selector__button")
      .forEach((button) => {
        button.addEventListener("click", () => {
          setTimeout(() => {
            changePrice(quantityInput.value);
          }, 0);
        });
      });
  }
}, 50);

setTimeout(() => {
  if (!executed) {
    console.warn("hulk-vd-price-update-custom.js not executed");
    clearInterval(intervalId);
  }
}, 15000);
